// extracted by mini-css-extract-plugin
export var headerCell = "_4p-1";
export var loadingSpinnerContainer = "_4p-4";
export var rowWrapper = "_4p-3";
export var standaloneTable = "_4p-5";
export var table = "_4p-0";
export var white = "_4p-2";